import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import bindMethods from 'auto-bind';
import styled, { withTheme } from 'styled-components';
import { Link } from 'react-router-dom';

import getUserById from '../../state/selectors/getUserById';
import UserForm from '../../forms/UserForm';
import FormHeadline from '../../components/form/FormHeadline';
import SSOButton from '../../components/SSOButton';
import { ButtonContainer, HeadlineContainer } from '../../components/form/FormStyles';
import getUserOrgByUserId from '../../state/selectors/getUserOrgByUserId';

const OrgContainer = styled.div`
  display: flex;
`;

const OrgLabel = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: ${props => props.theme.BLACK};
`;

const OrgValue = styled(Link)`
  font-size: 14px;
  font-weight: normal;
  color: ${props => props.theme.PRIMARY};
  margin-left: 5px;
  text-decoration: none;
`;

class EditUser extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
    // this holds an instance of Formik's submitForm function
    this.submitForm = null;
  }

  bindSubmitForm(submitForm) {
    this.submitForm = submitForm;
  }

  handleCancelButtonClick() {
    const { history } = this.props;
    return history.goBack();
  }

  handleSubmitForm(event) {
    if (this.submitForm) {
      this.submitForm(event);
    }
  }

  renderUserOrg() {
    const { userOrg, t } = this.props;

    if (!userOrg) {
      return null;
    }

    return (
      <OrgContainer>
        <OrgLabel>{`${t('Shared.General.Organization')}:`}</OrgLabel>
        <OrgValue to={`/orgs/${userOrg.orgId}`}>{userOrg.org.displayName}</OrgValue>
      </OrgContainer>
    );
  }

  render() {
    const { t, theme, user } = this.props;

    if (!user) {
      return null;
    }

    return (
      <div>
        <HeadlineContainer>
          <FormHeadline
            id="Users.Edit.Headline.GeneralInformation"
            headline={t('Pages.Users.Headlines.GeneralInformation')}
          />

          <ButtonContainer>
            <SSOButton
              id="Cancel"
              text={t('Shared.General.Cancel')}
              onClick={this.handleCancelButtonClick}
            />
            <SSOButton
              id="Submit"
              text={t('Shared.General.UpdateClose')}
              onClick={this.handleSubmitForm}
              backgroundColor={theme.PRIMARY}
            />
          </ButtonContainer>
        </HeadlineContainer>

        {this.renderUserOrg()}

        <UserForm bindSubmitForm={this.bindSubmitForm} user={user} />
      </div>
    );
  }
}

EditUser.propTypes = {
  history: PropTypes.object.isRequired, // supplied from React Router
  t: PropTypes.func.isRequired, // supplied from withTranslation
  theme: PropTypes.object.isRequired, // supplied from withTheme
  user: PropTypes.object.isRequired, // supplied from Redux
  userOrg: PropTypes.object, // supplied from Redux
};

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps.match.params;
  return {
    user: getUserById(state, id),
    userOrg: getUserOrgByUserId(state, id),
  };
};

const TranslatedComponent = withTranslation()(EditUser);
const ThemedComponent = withTheme(TranslatedComponent);
export default connect(mapStateToProps)(ThemedComponent);
